import { connect } from "react-redux";
import LeadershipTeamAlignment from "./LeadershipTeamAlignment";


const mapStateToProps = (state) => ({

    fetchBenchmarkAlignmentScoreApi: state.BenchmarkFilteringReducer.fetchBenchmarkAlignmentScoreApi
});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(LeadershipTeamAlignment);
